
import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { BodyEvent, CarEpisode, CarEvent, FaceEvent, HumanEpisode } from '@/api';
import { NButton } from '@/uikit';
import { DirectionEnum } from '@/components/common/deprecated/acknowledge-types';
import { RemoteMonitoringEvent } from '@/api/models/RemoteMonitoringEvent';

@Options({
  name: 'Acknowledge',
  components: { NButton }
})
export default class Acknowledge extends Vue {
  @Prop({ type: Object as PropType<FaceEvent | BodyEvent | CarEvent | HumanEpisode | CarEpisode | RemoteMonitoringEvent>, required: true })
  readonly item!: FaceEvent | BodyEvent | CarEvent | HumanEpisode | CarEpisode | RemoteMonitoringEvent;

  @Prop({ type: String, default: DirectionEnum.Horizontal })
  direction!: DirectionEnum;

  @Prop({ type: Boolean, default: false })
  readonly disabled!: boolean;

  wasAcknowledged = this.item.acknowledged;

  get text() {
    return this.isVertical ? '' : this.$t(`common.${this.wasAcknowledged ? 'acknowledged' : 'acknowledge'}`, 'f');
  }

  get icon() {
    return this.wasAcknowledged ? 'done-all' : this.isVertical ? 'unknown' : '';
  }

  get isVertical() {
    return this.direction === DirectionEnum.Vertical;
  }

  get classes(): Record<string, boolean> {
    return {
      acknowledge: true,
      acknowledge_horizontal: this.direction === DirectionEnum.Horizontal,
      acknowledge_vertical: this.direction === DirectionEnum.Vertical
    };
  }

  toggleAcknowledge() {
    const value = !this.wasAcknowledged;
    this.wasAcknowledged = value;
    this.$emit('action', 'acknowledge', { value });
  }

  @Watch('item.acknowledged')
  handleAcknowledge(v: boolean) {
    this.wasAcknowledged = v;
  }
}
